// Vouchers Constants
// ثوابت السندات

// Parent Account IDs for filtering
// معرفات الحسابات الرئيسية للفلترة
export const PARENT_ACCOUNTS = {
  // Cash parent account (01-002-000002)
  CASH: null as number | null, // سيتم تحديده من قاعدة البيانات
  
  // Banks parent account (01-001-000001)
  BANKS: null as number | null, // سيتم تحديده من قاعدة البيانات
};

// Note: These IDs should be fetched from the database
// We need to query:
// SELECT AccountId FROM ChartOfAccounts WHERE AccountCode = '01-002-000002' (Cash)
// SELECT AccountId FROM ChartOfAccounts WHERE AccountCode = '01-001-000001' (Banks)

// For now, we'll fetch them dynamically in the components

// Voucher Types
// أنواع السندات
export const VOUCHER_TYPES = {
  CR: {
    code: 'CR',
    nameEn: 'Cash Receipt',
    nameAr: 'سند قبض نقدي',
    prefix: 'CR-',
    color: '#4caf50' // green
  },
  CHR: {
    code: 'CHR',
    nameEn: 'Check Receipt',
    nameAr: 'سند قبض شيك',
    prefix: 'CHR-',
    color: '#2196f3' // blue
  },
  CP: {
    code: 'CP',
    nameEn: 'Cash Payment',
    nameAr: 'سند صرف نقدي',
    prefix: 'CP-',
    color: '#f44336' // red
  },
  CHP: {
    code: 'CHP',
    nameEn: 'Check Payment',
    nameAr: 'سند صرف شيك',
    prefix: 'CHP-',
    color: '#ff9800' // orange
  }
} as const;

// Voucher Status
// حالات السندات
export const VOUCHER_STATUS = {
  DRAFT: {
    code: 'Draft',
    nameEn: 'Draft',
    nameAr: 'مسودة',
    color: '#9e9e9e' // gray
  },
  POSTED: {
    code: 'Posted',
    nameEn: 'Posted',
    nameAr: 'مرحّل',
    color: '#4caf50' // green
  }
} as const;

// Side (Debit/Credit)
// الجانب المدين/الدائن
export const VOUCHER_SIDE = {
  DEBIT: 'Debit',
  CREDIT: 'Credit'
} as const;

// Payment Methods
// طرق الدفع
export const PAYMENT_METHODS = {
  CASH: {
    code: 'Cash',
    nameEn: 'Cash',
    nameAr: 'نقداً'
  },
  CHECK: {
    code: 'Check',
    nameEn: 'Check',
    nameAr: 'شيك'
  },
  BANK_TRANSFER: {
    code: 'BankTransfer',
    nameEn: 'Bank Transfer',
    nameAr: 'حوالة بنكية'
  },
  CREDIT_CARD: {
    code: 'CreditCard',
    nameEn: 'Credit Card',
    nameAr: 'بطاقة ائتمان'
  }
} as const;

// Helper function to get voucher type by code
// دالة مساعدة للحصول على نوع السند بالرمز
export const getVoucherType = (code: string) => {
  return Object.values(VOUCHER_TYPES).find(type => type.code === code);
};

// Helper function to get voucher status
// دالة مساعدة للحصول على حالة السند
export const getVoucherStatus = (code: string) => {
  return Object.values(VOUCHER_STATUS).find(status => status.code === code);
};

// Default currency
// العملة الافتراضية
export const DEFAULT_CURRENCY = 'KWD';

// Default exchange rate
// سعر الصرف الافتراضي
export const DEFAULT_EXCHANGE_RATE = 1;